import type { Action, ActionReducer } from '@ngrx/store';
import { createReducer, on } from '@ngrx/store';

import { CellarActions } from '@app/store/actions';
import type { CellarData } from '@app/types/cellar-data.type';

export type CellarState = Record<string, CellarData>;

export const initialCellarState: CellarState = {};

const reducer: ActionReducer<CellarState> = createReducer(
  initialCellarState,
  on(CellarActions.setData, (state: CellarState, { data }: { data: any }) => ({
    ...state,
    ...data,
  })),
  on(CellarActions.removeData, (state: CellarState, { key }: { key: string }) => {
    const updatedState: CellarState = { ...state };
    delete updatedState[key];

    return { ...updatedState };
  }),
  on(CellarActions.resetCellar, () => ({ ...initialCellarState })),
);

export function cellarReducer(state: CellarState | undefined, action: Action): CellarState {
  return reducer(state, action);
}
